import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, FormattedRelative } from 'react-intl';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import Messages from './Messages';
import s from './ConversationPopup.css';

class ConversationMessage extends React.Component {

  render() {
    const { message, isNew } = this.props;
    const user = message.get('user');
    const sentDate = new Date(message.get('created'));
    const formattedText = message.get('text')
    const wrappedStyle = cx(s.ConversationMessage, s.ConversationMessage__new);
    const messages = Messages();
    return (
      <li className={wrappedStyle}>
        {isNew && <div className={s.ConversationMessage_info}>
          <FormattedMessage {...messages.message_new_info} />
          </div>}
        <small className="ConversationMessage-author">
          {user.get('full_name')}&nbsp;
          <FormattedRelative value={sentDate} initialNow={new Date()}/>
        </small>
        <p 
          className={s.ConversationMessage_text} 
          dangerouslySetInnerHTML={{__html: formattedText }} 
        />
      </li>
    );
  }
}

ConversationMessage.propTypes = {
  message: PropTypes.object.isRequired,
  isNew: PropTypes.bool.isRequired,
};

export default withStyles(s)(ConversationMessage);


// WEBPACK FOOTER //
// ./src/components/ConversationPopup/ConversationMessage.js